import elementExists from "../utils/elementExists";

const BlogGrid = function () {
        const filterSelect = document.getElementById( 'blogFilter');
        if( elementExists( filterSelect )){
            filterSelect.addEventListener( 'change' , function( e ){
                const val = e.target.value;
                window.location.href = val;
            });            
        }

    // Build the articles grid programatically //
    // SAVE THIS IN CASE THEY DECIDE TO CHANGE IT
    // let articles_grid = document.querySelectorAll('.article-grid')
    // const articles_grid_sizer = function(){
    //     // let mql = window.matchMedia('(min-width: 992px)');
    //     if (articles_grid.length > 0  ){
    //         let articles = articles_grid[0].querySelectorAll('.article-grid__block');
    //         if (articles.length > 0){
    //             let n = 0;
    //             let i = 0;
    //             for (let i = 0; i < articles.length; i++) {
    //                 if ((i % 10) === 0 || i === 0 ){
    //                     articles[i].style.gridArea = (1 + 4*n) + ' / 1 / span 2 / span 2';
    //                     articles[i].classList.add('large');

    //                     if (articles.length > 9){
    //                         articles[i + 9].style.gridArea = (3 + 4*n) + ' / 3 / span 2 / span 2';
    //                         articles[i + 9].classList.add('large');
    //                     }
    //                     n++;
    //                 }
    //             }
    //         }
    //     }
    // }

    // if ( elementExists(articles_grid, false) ) {
    //     articles_grid_sizer();
    // }
}

export default BlogGrid;

